module.exports = __webpack_public_path__ + "img/bannerPeople.ed637ec8.png";